import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { Loader, ButtonModifier } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Button } from "@mui/material";
import useScreenWidth from "../../../hooks/useScreenWidth";
import { formatDate } from "../../../constants/helper";

const TampilPreOrder = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [noPreOrder, setNoPreOrder] = useState("");
  const [tipePreOrder, setTipePreOrder] = useState("");
  const [tanggalPreOrder, setTanggalPreOrder] = useState("");
  const [noRab, setNoRab] = useState("");
  const [tanggalDpRab, setTanggalDpRab] = useState("");
  const [keteranganPreOrder, setKeteranganPreOrder] = useState("");

  const navigate = useNavigate();
  let isEditableManager = user.tipeUser !== "ADMIN";
  // let isEditable = isEditableManager;
  let isEditable = true;

  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getPreOrderById();
  }, []);

  const getPreOrderById = async () => {
    setLoading(true);
    const response = await postRequest(
      `/preOrders/${id}`,
      {},
      navigate,
      dispatch
    );
    setNoPreOrder(response.data.noPreOrder);
    setTipePreOrder(response.data.tipePreOrder);
    setTanggalPreOrder(formatDate(response.data.tanggalPreOrder));
    setNoRab(response.data.rab.noRab);
    setTanggalDpRab(formatDate(response.data.rab.tanggalDpRab));
    setKeteranganPreOrder(response.data.keteranganPreOrder);
    setLoading(false);
  };

  const deletePreOrder = async (id) => {
    setLoading(true);
    await postRequest(`/deletePreOrder/${id}`, {}, navigate, dispatch);
    navigate("/daftarPreOrder");
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Proyek</h3>
      <h5 style={{ fontWeight: 400 }}>PO</h5>
      <hr />
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate("/daftarPreOrder")}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>
      <Box sx={buttonModifierContainer}>
        {isEditable && (
          <>
            <ButtonModifier
              id={id}
              kode={"test"}
              addLink={null}
              editLink={`/daftarPreOrder/preOrder/${id}/edit`}
              deleteUser={deletePreOrder}
              nameUser={noPreOrder}
            />
          </>
        )}
      </Box>
      <Form>
        <Card>
          <Card.Header>PO</Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode PO :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={noPreOrder}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tipe PO :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={tipePreOrder}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. PO :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={tanggalPreOrder}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. RAB :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={noRab} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. DP RAB :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={tanggalDpRab} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      as="textarea"
                      rows={4}
                      value={keteranganPreOrder}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Form>
    </Container>
  );
};

export default TampilPreOrder;

const buttonModifierContainer = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const subTitleText = {
  fontWeight: "900",
};
